import { FormInputText, FormInputTextProps } from '@eventr/common-storybook'
import { Box } from '@mui/material'

export const FormText = (props: FormInputTextProps) => {
    return (
        <Box>
            <FormInputText {...props} />
        </Box>
    )
}
